import React, { useState } from 'react';
import Input from 'shared/Input/Input';
import ButtonPrimary from 'shared/Button/ButtonPrimary';
import { useParams, Link } from 'react-router-dom';
import axios from 'axios';
import BgGlassmorphism from './BgGlassmorphism';

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
});

const ResetPassword: React.FC = () => {
  const { token } = useParams<{ token: string }>();
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(false);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = event.target;
    if (name === 'password') {
      setPassword(value);
    } else if (name === 'confirmPassword') {
      setConfirmPassword(value);
    }
  };

  const handleSubmit = async (event: React.FormEvent) => {
    event.preventDefault();
    setLoading(true);
    setMessage('');
  
    if (password !== confirmPassword) {
      setMessage('Passwords do not match');
      setLoading(false);
      return;
    }
  
    try {
      const response = await axios.put(
        `${process.env.REACT_APP_API_URL}/api/users/reset-password/${token}`,
        { password },
        { 
          headers: { 
            'Content-Type': 'application/json'
          }
        }
      );
      setMessage(response.data.message);
    } catch (error: any) {
      setMessage(
        error.response?.data?.message || 
        'Error resetting password. Please try again.'
      );
      console.error('Reset password error:', error);
    } finally {
      setLoading(false);
    }
  };
  return (
    <div className="nc-ResetPassword relative overflow-hidden">
      <BgGlassmorphism />
      <div className="container relative z-10 mb-24 lg:mb-32">
        <h2 className="my-20 flex items-center text-3xl leading-[115%] md:text-5xl md:leading-[115%] font-semibold text-neutral-100 justify-center">
          Reset Password
        </h2>
        <div className="max-w-md mx-auto space-y-6">
          <div className="bg-white/10 backdrop-blur-lg rounded-3xl p-8">
            <form className="grid grid-cols-1 gap-6" onSubmit={handleSubmit}>
              <label className="block">
                <span className="text-neutral-200 font-medium">New Password</span>
                <Input
                  type="password"
                  name="password"
                  placeholder="••••••••"
                  className="mt-1.5 bg-white/5 border-neutral-500"
                  value={password}
                  onChange={handleChange}
                  required
                />
              </label>
              <label className="block">
                <span className="text-neutral-200 font-medium">Confirm Password</span>
                <Input
                  type="password"
                  name="confirmPassword"
                  placeholder="••••••••"
                  className="mt-1.5 bg-white/5 border-neutral-500"
                  value={confirmPassword}
                  onChange={handleChange}
                  required
                />
              </label>
              <ButtonPrimary type="submit" disabled={loading}>
                {loading ? 'Resetting...' : 'Reset Password'}
              </ButtonPrimary>
            </form>
            {message && <div className="mt-4 text-neutral-200 text-sm text-center">{message}</div>}
          </div>
          <span className="block text-center text-neutral-300">
            Remembered your password?{' '}
            <Link to="/login" className="text-primary-500 hover:text-primary-400 font-medium">
              Login
            </Link>
          </span>
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;